import React, { useContext } from "react";
import PropTypes from "prop-types";
import { SimpleContext } from "../../../../store/context/simple-context";
import { getTrueClasses } from "../../../../helpers";
import "./index.scss";

const SeeAllFeatures = ({ period }) => {
  const {
    data: { tableState },
    translate: { t },
    update: { tableOpenHandler },
  } = useContext(SimpleContext);

  return (
    <div
      className={getTrueClasses(
        "GP-C-SAF",
        tableState[period].open && "GP-C-SAF_hide"
      )}
      onClick={() => tableOpenHandler(period, true)}
    >
      <p className="GP-C-SAF__text">{t("See all features")}</p>
    </div>
  );
};
SeeAllFeatures.propTypes = {
  period: PropTypes.string,
};
export default SeeAllFeatures;
